import React from 'react';


//https://reactjs.org/docs/lists-and-keys.html#extracting-components-with-keys
class TestimonialItem extends React.Component {

	render() {
		return (
			<li className="list__item item--testimonial">
				<blockquote>
					<p>{this.props.quote}</p>
				</blockquote>				
				<span className="author">
					{this.props.desc ? (						
						<React.Fragment>
							{this.props.title}, {this.props.desc}
						</React.Fragment>					
					) : (
						<React.Fragment>
							{this.props.title}
						</React.Fragment>
					)}
				</span>									
			</li>
		);
	}
}

export default TestimonialItem;